module.exports = __webpack_public_path__ + "static/media/virus-banner.a97bacd2.jpg";